import { createReducer } from '@reduxjs/toolkit';

import postCoMissingParts from '../../../thunks/coilovers/orders/postCoMissingParts';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

const postCoMissingPartsReducer = createReducer(initialState, {
  [postCoMissingParts.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postCoMissingParts.fulfilled]: (state, { payload: { data } }) => {
    return {
      ...state,
      loading: false,
      data,
    };
  },
  [postCoMissingParts.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default postCoMissingPartsReducer;
